export function truncateString(str: string, maxLength: number, trailing = '...'): string {
  if (str.length <= maxLength) return str;

  const trimmedStr = str.slice(0, maxLength);

  const lastSpaceIndex = trimmedStr.lastIndexOf(' ');
  const truncatedStr = trimmedStr.slice(0, lastSpaceIndex > 0 ? lastSpaceIndex : maxLength);

  return `${truncatedStr}${trailing}`;
}
